import Vue from 'vue'
import service from '../services/bankAccountsService'

export function useBankAccountReports() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false,
    account:{}
  })

  async function getReports(params = {}) {
    state.loading = true
    try {
      const response = await service.getReports(params)
      state.items = response.reports.current_page === 1
        ? [...response.reports.data]
        : [...state.items, ...response.reports.data]
      state.account = response.account
      state.currentPage = response.reports.current_page
      state.lastPage = response.reports.last_page
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getReports }
}
